// src/components/general/Management/ImageUploadField.jsx

// npm install antd-img-crop

import React, { useState } from "react";
import { Upload, App } from "antd";
import ImgCrop from "antd-img-crop";
import { InboxOutlined } from "@ant-design/icons";

const ImageUploadField = ({ value, onChange }) => {
    const { message } = App.useApp();

    const [fileList, setFileList] = useState(() => {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string") {
            return [
                {
                    uid: "-1",
                    name: "Đã có ảnh",
                    status: "done",
                    url: value,
                },
            ];
        }
        return [value];
    });

    const handleBeforeUpload = async (file) => {
        try {
            const croppedBlob = await cropImageToCircle(file);
            const croppedFile = new File([croppedBlob], file.name, {
                type: file.type,
            });

            const newFileObj = {
                uid: file.uid,
                name: file.name,
                status: "done",
                url: URL.createObjectURL(croppedBlob),
                originFileObj: croppedFile,
            };

            setFileList([newFileObj]);
            onChange?.(croppedFile); // Trả về ảnh đã crop

            return false; // Ngăn upload mặc định
        } catch (err) {
            console.error("Crop error:", err);
            message.error("Không thể crop ảnh");
            return false;
        }
    };

    const cropImageToCircle = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                const img = new Image();
                img.onload = () => {
                    const size = Math.min(img.width, img.height);
                    const canvas = document.createElement("canvas");
                    canvas.width = size;
                    canvas.height = size;
                    const ctx = canvas.getContext("2d");

                    // Tạo vùng crop hình tròn
                    ctx.beginPath();
                    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
                    ctx.closePath();
                    ctx.clip();
                    ctx.drawImage(img, 0, 0, size, size, 0, 0, size, size);

                    canvas.toBlob((blob) => resolve(blob), file.type);
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
        });
    };

    return (
        <ImgCrop
            cropShape="round"
            aspect={1}
            showGrid={false}
            modalTitle="Chỉnh sửa ảnh"
            modalClassName="img-crop-rounded-modal"
        >
            <Upload.Dragger
                accept="image/*"
                listType="picture"
                fileList={fileList}
                maxCount={1}
                onRemove={() => {
                    setFileList([]);
                    onChange?.(null);
                }}
                beforeUpload={handleBeforeUpload}
                style={{ width: "100%" }}
            >
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                    Kéo thả ảnh vào đây hoặc nhấn để chọn
                </p>
            </Upload.Dragger>
        </ImgCrop>
    );
};

export default ImageUploadField;
